import {Map, List} from 'immutable'
import types from '../types/catalog'
import categoryListTypes from '../types/categoryList'
import headerTypes from '../../header/types/header'

const initialRoot = Map({
  items: List(),
  error: '',
  lastSearchID: 0,
  limit: 8,
  offset: 0,
  isSearching: false,
  category: 1,
  search: '',
  isDirty: false,
  expectMore: true,
  id: 0,
})


function root(state = initialRoot, action) {

  function isChanged(property) {
    return state.get(property) !== initialRoot.get(property)
  }

  let newList
  switch (action.type) {
    case headerTypes.SET_SEARCH:
      return state.set('search', action.payload.search)
    case types.SEARCH:
      return state.merge({
        limit: initialRoot.get('limit'),
        offset: initialRoot.get('offset'),
        expectMore: true,
        isSearching: true,
        lastSearchID: action.payload.lastSearchID,
      })
    case types.SEARCH_SUCCESS:
      newList = List(action.payload.items)
      return state.merge({
        isSearching: false,
        items: newList,
        error: '',
        isDirty: isChanged('limit') || isChanged('offset') || isChanged('category') || isChanged('search'),
        expectMore: action.payload.quantity > newList.size,
      })
    case types.SEARCH_FAIL:
      return state.merge({
        isSearching: false,
        error: action.payload.error,
        isDirty: isChanged('limit') || isChanged('offset') || isChanged('category'),
      })
    case types.SEARCH_MORE:
      return state.merge({
        isSearching: true,
      })
    case types.SEARCH_MORE_SUCCESS:
      newList = state.get('items').concat(List(action.payload.items))
      return state.merge({
        isSearching: false,
        items: newList,
        expectMore: action.payload.quantity > newList.size,
        error: '',
      })
    case types.SEARCH_MORE_FAIL:
      return state.merge({
        isSearching: false,
        error: action.payload.error,
      })
    case types.SET_CATALOG_ID:
      return state.set('id', action.payload.id)
    case categoryListTypes.FETCH_FIRST_LEVEL_CATEGORIES:
      return state.set('category', action.payload.selected)
    case categoryListTypes.SELECT_CATEGORY:
      return state.set('category', action.payload.selected)
    case categoryListTypes.DESELECT_CATEGORY:
      return state.set('category', action.payload.selected)
    case types.SET_OFFSET:
      return state.set('offset', action.payload.offset)
    case types.SET_LIMIT:
      return state.set('limit', action.payload.limit)
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/catalog/reducers/catalog.js